<script>
  import { getContext } from "svelte";
  import ClipboardIcon from "../icons/clipboard.svelte";
  import { copy as clipboardCopy } from "../util/clipboard.js";

  export let label = "";
  export let value = "";
  export let small = false;
  const toast = getContext("toast");

  async function copy() {
    if (!value) return;
    try {
      const ret = await clipboardCopy(value);
      if (ret) {
        const prefix = label ? `${label} copied` : "Copied";
        if (toast) toast.show(`${prefix} to clipboard.`);
      }
    } catch (error) {
      console.error(error.message);
      if (toast) toast.error(`Error copying to clipboard`);
    }
  }

  // function fallbackCopyTextToClipboard(string) {
  //   let textarea;
  //   let result;

  //   try {
  //     textarea = document.createElement("textarea");
  //     textarea.setAttribute("readonly", true);
  //     textarea.setAttribute("contenteditable", true);
  //     textarea.style.position = "fixed"; // prevent scroll from jumping to the bottom when focus is set.
  //     textarea.style.top = "-99999px";
  //     textarea.style.left = "-99999px";
  //     textarea.value = string;

  //     document.body.appendChild(textarea);

  //     textarea.focus();
  //     textarea.select();

  //     const range = document.createRange();
  //     range.selectNodeContents(textarea);

  //     const sel = window.getSelection();
  //     sel.removeAllRanges();
  //     sel.addRange(range);

  //     textarea.setSelectionRange(0, textarea.value.length);
  //     result = document.execCommand("copy");
  //   } catch (err) {
  //     console.error(err);
  //     result = null;
  //   } finally {
  //     document.body.removeChild(textarea);
  //   }
  // }
</script>

<button
  class="noselect copy-button"
  class:small
  alt="Copy to clipboard"
  on:click={(ev) => {
    ev.preventDefault();
    copy();
  }}
>
  <ClipboardIcon />
</button>

<style>
  button {
    width: 24px;
    height: 24px;
    padding: 0px;
    box-sizing: border-box;
    margin: 0;
    background: none;
    /* background: hsl(0, 0%, 90%); */
    appearance: none;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
  .small {
    width: 18px;
    height: 18px;
  }
  :global(.copy-button svg) {
    background: transparent;
    width: 100%;
    height: auto;
  }
</style>
